import { createSlice } from "@reduxjs/toolkit";
export const GalerieContratReducer = createSlice({
    name: "Galerie",
    initialState: { isSeeGalerie: false,seeIdentityCards:false,seeGalerieBiens:false },
    reducers: {
      toogleGalerie: (state) => {
        return { ...state, isSeeGalerie: true };
      },
      handleSeeIdentityCard :(state)=>{
        return {...state,seeIdentityCards:true}
      },
      handleSeeGalerieBiens :(state)=>{
        return {...state,seeGalerieBiens:true}
      }

    },
  });

  export const { toogleGalerie,handleSeeIdentityCard,handleSeeGalerieBiens } = GalerieContratReducer.actions;

export default GalerieContratReducer.reducer;